<template>
  <div class="content-main">
    <HeaderBar :text="life.header" :backgroundUrl="life.headerUrl"></HeaderBar>
    <MySchool :mySchool="life.mySchool"></MySchool>
    <Course :course="life.course"></Course>
  </div>
</template>

<script>
import HeaderBar from '../COMMON/HeaderBar'
import MySchool from './Life_Myschool.vue'
import Course from './Life_Course.vue'

export default {
  components: {
    HeaderBar,
    MySchool,
    Course
  },
  props: ['life'],
  data () {
    return {
    }
  }
}
</script>

<style scoped>
  .content-main {
    padding-bottom: 60px 0;
    background-color: rgba(200, 200, 200, 0.3);
  }

  .content {
    padding: 60px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/STUDENTS/Life.vue